import React from "react";
import PropTypes from "prop-types";

export default function TypoTableRow(props) {
  return (
    <tr>
      <td className="align-middle">{props.tag && <div>{props.tag}</div>}</td>
      <td className="align-middle">
        {props.fontWeight && <div>{props.fontWeight}</div>}
      </td>
      <td className="align-middle">
        {props.lineHeight && <div>{props.lineHeight}</div>}
      </td>
      <td className="align-middle">
        {props.mobile && <div>{props.mobile}</div>}
      </td>
      <td className="align-middle">
        {props.desktop && <div>{props.desktop}</div>}
      </td>
    </tr>
  );
}

TypoTableRow.propTypes = {
  tag: PropTypes.object,
  fontWeight: PropTypes.string,
  lineHeight: PropTypes.string,
  mobile: PropTypes.string,
  desktop: PropTypes.string,
};
